import { useSelector } from "react-redux";

/**
 * Hook to read subscription status from the centralized Redux store.
 * The SubscriptionProvider handles fetching + polling in the background.
 *
 * @returns {{ canPlay: boolean, canPlayLoading: boolean, daysRemaining: number }}
 */
export var useSubscriptionStatus = function () {
  var subscription = useSelector(function (state) { return state.Subscription; });

  return {
    canPlay: subscription.canPlay,
    canPlayLoading: subscription.loading,
    daysRemaining: subscription.daysRemaining,
  };
};